// font-awesome setup
import { library } from "@fortawesome/fontawesome-svg-core"
// import individual brand icons
import {
  faBluesky,
  faFacebookSquare,
  faGithub,
  faGithubSquare,
  faGoogle,
  faHackerNews,
  faHackerNewsSquare,
  faHubspot,
  faLinkedin,
  faMailchimp,
  faMastodon,
  faProductHunt,
  faSlack,
  faSquareBluesky,
  faStackOverflow,
  faTwitter,
  faTwitterSquare,
  faWhatsappSquare,
} from "@fortawesome/free-brands-svg-icons"
// import individual icons as needed
import {
  faAddressBook,
  faAddressCard,
  faAlignJustify,
  faAngleDoubleDown,
  faArchive,
  faArrowCircleRight,
  faArrowDown,
  faArrowDownAZ,
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowsDownToLine,
  faArrowsLeftRight,
  faArrowsRotate,
  faArrowsTurnToDots,
  faArrowsUpDown,
  faArrowsUpToLine,
  faArrowUp,
  faArrowUpRightFromSquare,
  faAsterisk,
  faAt,
  faBackwardFast,
  faBars,
  faBarsStaggered,
  faBinoculars,
  faBold,
  faBolt,
  faBook,
  faBorderNone,
  faBrain,
  faBroom,
  faBuilding,
  faBullseye,
  faC,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDay,
  faCalendarDays,
  faCalendarWeek,
  faCaretDown,
  faCaretUp,
  faChartBar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleDot,
  faCircleQuestion,
  faCircleXmark,
  faCity,
  faClapperboard,
  faClipboardCheck,
  faClipboardList,
  faClock,
  faClone,
  faCloudUploadAlt,
  faCode,
  faCodeBranch,
  faCodeMerge,
  faCog,
  faCogs,
  faColumns,
  faComment,
  faCommentDots,
  faComments,
  faCompress,
  faCopy,
  faD,
  faDatabase,
  faDiagramProject,
  faDollarSign,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEarthAmerica,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopesBulk,
  faEnvelopeSquare,
  faEquals,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faExternalLinkSquare,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileAudio,
  faFileCirclePlus,
  faFileCode,
  faFileContract,
  faFileExcel,
  faFileImage,
  faFileImport,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faFilter,
  faFolderOpen,
  faFolderTree,
  faFont,
  faGlobe,
  faGreaterThan,
  faGreaterThanEqual,
  faGrip,
  faGripLines,
  faGripLinesVertical,
  faGripVertical,
  faHandHoldingDollar,
  faHandPointer,
  faHandshake,
  faHandshakeAngle,
  faHashtag,
  faHeadphones,
  faHome,
  faHourglassHalf,
  faImage,
  faImages,
  faInbox,
  faInfoCircle,
  faItalic,
  faKey,
  faKeyboard,
  faL,
  faLandmark,
  faLayerGroup,
  faLessThan,
  faLessThanEqual,
  faLightbulb,
  faLink,
  faLinkSlash,
  faList,
  faListCheck,
  faListOl,
  faListUl,
  faLocationArrow,
  faLock,
  faLockOpen,
  faMapMarker,
  faMapMarkerAlt,
  faMedal,
  faMicrophone,
  faMicrophoneSlash,
  faMinus,
  faMinusSquare,
  faMoneyBillTrendUp,
  faMoneyBillWave,
  faNotEqual,
  faObjectGroup,
  faPalette,
  faPaperclip,
  faPaperPlane,
  faPaste,
  faPen,
  faPeopleArrows,
  faPercent,
  faPersonRunning,
  faPhone,
  faPhoneAlt,
  faPhoneSquare,
  faPlane,
  faPlay,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faQuestion,
  faQuestionCircle,
  faQuoteLeft,
  faR,
  faRepeat,
  faRobot,
  faRotate,
  faRotateLeft,
  faRssSquare,
  faS,
  faSearch,
  faShapes,
  faShareNodes,
  faSignal,
  faSignOutAlt,
  faSitemap,
  faSlidersH,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faSquareArrowUpRight,
  faSquareH,
  faSquareShareNodes,
  faSquareUpRight,
  faStar,
  faStickyNote,
  faStop,
  faStrikethrough,
  faSync,
  faTable,
  faTableCells,
  faTableCellsLarge,
  faTag,
  faTags,
  faTerminal,
  faThList,
  faThumbtack,
  faTicket,
  faTimes,
  faToggleOn,
  faTools,
  faTrash,
  faTrashAlt,
  faUndo,
  faUnlink,
  faUpload,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserAlt,
  faUserCircle,
  faUserEdit,
  faUserFriends,
  faUserLock,
  faUserPlus,
  faUsers,
  faUserTie,
  faUtensils,
  faWandMagicSparkles,
  faXmark,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

library.add(
  faAddressBook,
  faAddressCard,
  faAngleDoubleDown,
  faBroom,
  faBullseye,
  faChartBar,
  faChartLine,
  faArchive,
  faArrowUp,
  faArrowDown,
  faArrowRightArrowLeft,
  faArrowCircleRight,
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faSquareArrowUpRight,
  faUpRightAndDownLeftFromCenter,
  faEarthAmerica,
  faDownLeftAndUpRightToCenter,
  faArrowUpRightFromSquare,
  faArrowsUpDown,
  faArrowsUpToLine,
  faArrowsDownToLine,
  faArrowsTurnToDots,
  faBackwardFast,
  faBolt,
  faBrain,
  faBars,
  faObjectGroup,
  faBorderNone,
  faCalendar,
  faCalendarDay,
  faCalendarDays,
  faCalendarWeek,
  faCircle,
  faClock,
  faHourglassHalf,
  faRepeat,
  faTicket,
  faExpand,
  faAlignJustify,
  faBarsStaggered,
  faBinoculars,
  faBold,
  faBook,
  faFont,
  faHashtag,
  faPercent,
  faHome,
  faImage,
  faInfoCircle,
  faKey,
  faKeyboard,
  faCity,
  faPlane,
  faPlay,
  faRotate,
  faRotateLeft,
  faRssSquare,
  faQuestionCircle,
  faQuestion,
  faBuilding,
  faCaretUp,
  faColumns,
  faCog,
  faCogs,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCaretDown,
  faCalendarAlt,
  faCircleQuestion,
  faCircleXmark,
  faClapperboard,
  faClone,
  faCodeBranch,
  faCodeMerge,
  faComment,
  faComments,
  faCommentDots,
  faExternalLinkAlt,
  faExternalLinkSquare,
  faFileImport,
  faFileContract,
  faFileCirclePlus,
  faHandshakeAngle,
  faHandPointer,
  faLocationArrow,
  faLightbulb,
  faHeadphones,
  faLandmark,
  faPalette,
  faPaperclip,
  faSpinner,
  faCalendarCheck,
  faClipboardList,
  faClipboardCheck,
  faCheck,
  faCheckSquare,
  faCopy,
  faDatabase,
  faDiagramProject,
  faDollarSign,
  faEdit,
  faEnvelope,
  faEnvelopesBulk,
  faEye,
  faEyeSlash,
  faItalic,
  faListOl,
  faListUl,
  faPen,
  faMedal,
  faPersonRunning,
  faPeopleArrows,
  faHandshake,
  faComment,
  faPlus,
  faList,
  faSearch,
  faShapes,
  faTag,
  faTags,
  faCheckDouble,
  faToggleOn,
  faTools,
  faSignOutAlt,
  faStrikethrough,
  faSortUp,
  faSortDown,
  faSort,
  faArrowDownAZ,
  faTimes,
  faTrash,
  faUserAlt,
  faUserEdit,
  faUserLock,
  faUtensils,
  faUsers,
  faUserFriends,
  faUserPlus,
  faSync,
  faAt,
  faLink,
  faLinkSlash,
  faUnlink,
  faFilter,
  faFolderOpen,
  faFolderTree,
  faDownload,
  faUser,
  faMinus,
  faPlus,
  faSpinner,
  faTable,
  faGithub,
  faGithubSquare,
  faTwitter,
  faTwitterSquare,
  faFacebookSquare,
  faWhatsappSquare,
  faLinkedin,
  faMastodon,
  faHackerNews,
  faHackerNewsSquare,
  faStackOverflow,
  faSlack,
  faProductHunt,
  faHubspot,
  faMailchimp,
  faBluesky,
  faSquareBluesky,
  faPhone,
  faPhoneAlt,
  faPhoneSquare,
  faEllipsisH,
  faEllipsisV,
  faEnvelopeSquare,
  faEnvelopeOpen,
  faExclamationTriangle,
  faCode,
  faLock,
  faLockOpen,
  faGlobe,
  faMapMarkerAlt,
  faMapMarker,
  faGrip,
  faGripLines,
  faGripLinesVertical,
  faGripVertical,
  faMoneyBillWave,
  faMoneyBillTrendUp,
  faHandHoldingDollar,
  faLayerGroup,
  faMinusSquare,
  faSquareShareNodes,
  faSquareUpRight,
  faPaste,
  faPlusSquare,
  faPlusCircle,
  faTableCells,
  faShareNodes,
  faArrowsLeftRight,
  faThList,
  faStar,
  faUpload,
  faImages,
  faSitemap,
  faFile,
  faFileAlt,
  faFileImage,
  faFileVideo,
  faFileAudio,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileCode,
  faFileCirclePlus,
  faCloudUploadAlt,
  faC,
  faD,
  faL,
  faR,
  faS,
  faAsterisk,
  faSlidersH,
  faTableCellsLarge,
  faUndo,
  faWandMagicSparkles,
  faSignal,
  faEquals,
  faNotEqual,
  faGreaterThan,
  faGreaterThanEqual,
  faLessThan,
  faLessThanEqual,
  faListCheck,
  faQuoteLeft,
  faTerminal,
  faXmark,
  faCircleDot,
  faCheckCircle,
  faUserCircle,
  faStickyNote,
  faPlug,
  faThumbtack,
  faMicrophone,
  faMicrophoneSlash,
  faUserTie,
  faSquareH,
  faCompress,
  faRobot,
  faPaperPlane,
  faStop,
  faTrashAlt,
  faInbox,
  faGoogle
)

export default FontAwesomeIcon
